module.exports = __webpack_public_path__ + "static/media/logo.3d1e23c2.svg";